import { render, staticRenderFns } from "./UiBlockDocList.vue?vue&type=template&id=3acffb04&scoped=true"
import script from "./UiBlockDocList.vue?vue&type=script&lang=js"
export * from "./UiBlockDocList.vue?vue&type=script&lang=js"
import style0 from "./UiBlockDocList.vue?vue&type=style&index=0&id=3acffb04&prod&scoped=true&lang=css"
import style1 from "./uiBlockShared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acffb04",
  null
  
)

export default component.exports